import _get from 'lodash/get';

import { objectToCamelCase } from '../libs/format';

export function selectUser(state) {
  return objectToCamelCase(_get(state, 'user.core.value'));
}
